// extracted by mini-css-extract-plugin
module.exports = {"osbirb4":"osbirb4","c7c8n0j":"c7c8n0j","w1fl24i0":"w1fl24i0","s1nhgtzh":"s1nhgtzh","sd3xm65":"sd3xm65","sinpl2":"sinpl2"};